import type { ReactNode } from 'react';

/**
 * 空态（Skill pages.md「空态」）。
 * 白底 8% 边 16 圆角、**无阴影**、居中；h3 17 + 副文 muted + 主色文字链。
 * 不用 Ant Empty，不上大插画。
 *
 * 空库与空筛必须分开：「还没有 X」vs「没有匹配的 X」——由调用方传不同文案。
 */
export function EmptyHint({
  title,
  desc,
  actionText,
  onAction,
  page = false,
  icon,
  tone,
}: {
  title: string;
  desc?: ReactNode;
  actionText?: string;
  onAction?: () => void;
  /**
   * 整页级空态。Skill 的 36×24 适合面板内的小空态，
   * 整页空着时在 1440 宽下会显得小气，这里放大到 72×40 并把标题提到 20。
   * 基线不动，只加修饰类（见 global.css 的 .empty-hint.is-page）。
   */
  page?: boolean;
  /** 图标与它的底色。整页空态给一个色块当视觉锚点，纯文字会显得像出错了 */
  icon?: ReactNode | undefined;
  tone?: string | undefined;
}) {
  return (
    <div className={page ? 'empty-hint is-page' : 'empty-hint'}>
      {page && icon ? (
        <span className="icon-chip is-lg" style={{ background: tone ?? '#0071e3' }}>
          {icon}
        </span>
      ) : null}
      <h3>{title}</h3>
      {desc ? <p>{desc}</p> : null}
      {actionText && onAction ? (
        <button type="button" className="empty-hint-action" onClick={onAction}>
          {actionText}
        </button>
      ) : null}
    </div>
  );
}
